/*
 *   File : scroll-info.js
 *   Author : https://evoqins.com
 *   Description : scroll info component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React from "react";

export default function ScrollInfo() {
  return (
    <div className="d-flex align-items-center column-gap-2">
     <img
  style={{ transform: "rotate(90deg)" }}
  width={24}
  src={require("../../Assets/Images/Components/Other/scroll.gif")}
  alt="scroll-right"
/>

      <p className="mb-0 fw-400 fs-12 text-eerie-black lh-1 ">
        Scroll horizontally for view more information
      </p>
    </div>
  );
}
